<template>
  <BLayoutList
    :title="pageTitle"
    :create-route="createRoute"
    :skeleton="isLoadingAsyncData"
  >
    <template #filter>
      <ComponentFilter
        :data="filters"
        :skeleton="isLoadingAsyncData"
        @change="onChangeFilter"
      />
    </template>

    <BTableCommon
      v-model="selected"
      type="files"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      @change:pagination="onChangePagination"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
    />
  </BLayoutList>
</template>

<script>
import { lkFilePermissions as Permissions } from '@/helpers/enums/permission-models'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { FileModel as Model } from './Model'
import { filesStoreModule as StoreModule } from './store'
import { FILES_ROUTES as ROUTES } from './utils'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'
import ComponentFilter from './components/FilesFilter.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)


/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'ViewFilesList',
  components: {
    BLayoutList,
    BTableCommon,
    ComponentFilter,
  },
  mixins: [
    listMixin,
  ],
  computed: {
    createRoute() {
      const editable = this.$access(Permissions.create)
      return editable ? { name: ROUTES.CREATE } : void 0
    },
  },
}
</script>
